import { useSearchParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Seo } from '@/components/Seo';
import { Container } from '@/components/ui/Container';
import { PageHeader } from '@/components/ui/PageHeader';
import { CarBooking } from './CarBooking';

export function CarBookingPage() {
  const [params] = useSearchParams();
  const car = params.get('car') || undefined;
  return (
    <>
      <Seo title="Hire a car" description="Hire a car from Grace Haven in Gaborone — choose your vehicle and dates. We'll confirm availability by email; no payment is taken now." />
      <PageHeader eyebrow="Grace Haven Car Hire" title="Hire a car" intro="Choose your vehicle and dates. We'll confirm availability by email — no payment is taken now." />
      <section className="bg-cream py-16">
        <Container>
          <Link to="/cars" className="inline-flex items-center gap-1.5 font-body text-sm font-medium text-gold-deep transition hover:text-espresso">
            <ArrowLeft size={15} /> Back to the fleet
          </Link>
          <CarBooking initialCarId={car} />
        </Container>
      </section>
    </>
  );
}
